import { SHARED_ITEMS_GRID_COLS } from 'Modules/sharedItems/index.constants';
import React from 'react';
import { cn } from '~/lib/utils';

export const SharedItemsListHeader: React.FC = () => {
  return (
    <div
      role="row"
      className={cn(
        'grid h-[40px] items-center gap-4 overflow-y-auto border-b border-border bg-muted/40 px-4 text-[12px] [scrollbar-gutter:stable]',
        SHARED_ITEMS_GRID_COLS
      )}
      data-testid="shared-items-list-header"
    >
      <div role="columnheader">File / link name</div>
      <div role="columnheader">Shared by</div>
      <div role="columnheader">Date</div>
    </div>
  );
};
